"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DutchBoolean = void 0;
var DutchBoolean;
(function (DutchBoolean) {
    DutchBoolean["True"] = "Ja";
    DutchBoolean["False"] = "Nee";
})(DutchBoolean || (exports.DutchBoolean = DutchBoolean = {}));
(function (DutchBoolean) {
    function fromBoolean(value) {
        if (value === undefined) {
            return undefined;
        }
        return value ? DutchBoolean.True : DutchBoolean.False;
    }
    DutchBoolean.fromBoolean = fromBoolean;
    function toBoolean(dutchBoolean) {
        if (dutchBoolean === undefined) {
            return undefined;
        }
        return dutchBoolean === DutchBoolean.True;
    }
    DutchBoolean.toBoolean = toBoolean;
})(DutchBoolean || (exports.DutchBoolean = DutchBoolean = {}));
